import axios from 'axios';
import {
  BoostsPaymentPayload,
  BoostsMakePayment,
  PaymentErrorObject,
} from '../CheckoutTypes';
import flashMessage from '../../../flash_message/helpers/get_flash_message';
import trackEvent from '../../../../helpers/gtm/eventPush';

async function makePayment({
  affiliateId,
  amount,
  context,
  currency,
  customerServiceContactDetails,
  domain,
  paymentProvider,
  platform,
  products,
  successCallback,
  successUrl,
  token,
  userId,
}: BoostsMakePayment) {
  const payload = <BoostsPaymentPayload>{
    charge: {
      currency,
      amount,
    },
    external_transaction: {
      service: {
        type: paymentProvider,
      },
    },
    order_id: token,
    products: products,
    source: {
      domain: domain,
      platform: platform,
    },
    token,
    user: {
      id: userId,
    },
  };

  if (context) {
    payload.context = context;
  }
  if (affiliateId) {
    payload.affiliate = {
      id: affiliateId,
    };
  }

  try {
    const response = await axios.post(`/api/1.0/payments`, payload);
    successCallback(response.data.data);
    trackEvent({
      category: 'purchase',
      action: `${products[0].quantity} Extra Boost_purchase`,
      label: `${currency === 'gbp' ? '£' : '$'}${(amount / 100).toFixed(
        2,
      )}|${successUrl}|context=NULL`,
    });
    return window.location.assign(successUrl);
  } catch (error) {
    if (error.response && error.response.status == 400) {
      const { errors } = error.response.data;
      const paymentAction = errors.find((err) => err.code === 3005);
      if (paymentAction) {
        return <PaymentErrorObject>{
          actionRequired: true,
          subscription: false,
          client_secret: paymentAction.data.client_secret,
          message: paymentAction.message,
          paymentProvider: payload.external_transaction.service.type,
        };
      }
      // this will need sorting out
      const errorMessage =
        errors[0].code === 2022
          ? 'The charge value is invalid'
          : `Please try again. If this problem persists, then contact customer services on ${customerServiceContactDetails.phoneNumber} or ${customerServiceContactDetails.email}`;
      return <PaymentErrorObject>{
        actionRequired: false,
        message: errorMessage,
        subscription: false,
        paymentProvider: payload.external_transaction.service.type,
      };
    }
    // probably a 500 - so what to do?
    return flashMessage.showErrorMessage({
      heading: 'Payment error',
      text: `Sorry, we had a problem processing your payment. Please contact Customer Services on ${customerServiceContactDetails.phoneNumber} or ${customerServiceContactDetails.email}`,
    });
  }
}

export default makePayment;
